import { styled } from '@vw-marketing/us-components';
export const InputZipWrapper: any = styled.div`
  display: inline-table;
  width: 100%;
`;

export const InputContainer: any = styled.div`
  padding: 4px 0 10px 0;
`;

export const SubmitButtonWrapper: any = styled.div`
  padding-top: 26px;
`;

export const RichtextWrapper: any = styled.div`
  a {
    color: inherit;
  }
`;
